import React from 'react';
import { useModal } from '../../../context/ModalContext';
import { ModalBase } from './ModalBase';

export function ContratarModal() {
  const { contratarInfo } = useModal();

  return (
    <ModalBase>
      <h3 className="modal-box__title">Contratar serviço</h3>

      <div style={{
        background: '#E9F7FC',
        borderRadius: '10px',
        padding: '16px 18px',
        marginBottom: '20px',
      }}>
        <div style={{ fontSize: '14.5px', fontWeight: 700, color: '#12A9DC', marginBottom: '4px' }}>
          {contratarInfo.serviceName}
        </div>
        <div style={{ fontSize: '13.5px', color: '#2F3857' }}>
          {contratarInfo.partnerName}
        </div>
      </div>

      <p style={{ fontSize: '14px', color: '#424242', lineHeight: 1.6, textAlign: 'center', margin: '0 0 22px' }}>
        Para contratar este serviço, acesse o aplicativo WashPass. A contratação é feita diretamente no app com segurança e praticidade.
      </p>

      <button className="modal-form__submit" style={{ marginBottom: '12px' }}>
        Abrir o app
      </button>
      <button
        className="modal-form__submit"
        style={{ background: '#fff', color: '#12A9DC', border: '1.5px solid #12A9DC' }}
      >
        Baixar o app
      </button>
    </ModalBase>
  );
}
